import $ from 'jquery'
import SimpleTooltip from './SimpleTooltip'

class SimpleSingletonTooltip extends SimpleTooltip {
    constructor() {
        super({extraClass: 'simpleSingletonTooltip'})

        this.state = {
            text: '',
            html: '',
            extraClass: '',
        }

        this.onStatePropertyChanged('text', text => {
            this.setText(text)
        })

        this.onStatePropertyChanged('html', html => {
            this.setHtml(html)
        })

        this.onStatePropertyChanged('extraClass', (newExtraClass, oldExtraClass) => {
            this.$el.removeClass(oldExtraClass)
            this.$el.addClass(newExtraClass)
        })
    }
}

let instance = null
export const getInstance = () => {
    if (instance === null) {
        instance = new SimpleSingletonTooltip().init($('body'))
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/js/SimpleSingletonTooltip.js